import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../services/api';

/**
 * ProtectedRoute component to handle authentication-based routing
 * Redirects to login page if user is not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isUserAuthenticated = authService.isAuthenticated();

  if (!isUserAuthenticated) {
    // Redirect to login page if not authenticated
    // Save the attempted URL for redirecting after successful login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
